class CustomSDKIntegration {

  static alpha_factor_contour = 1;
  static alpha_factor_eyeshadow = 1;
  static SDKLoaded=false;

  constructor() {
    setTimeout(function () {
      window.CustomSDKIntegration.RegisterMultiVariantProductsEvents();
    }, 1000);
    this.CanvasImageBeforeZoom = null;
  }

  ShowSDKContainers() {
    // if (document.getElementsByClassName('container-tryon-media')[0].style.display.toLowerCase() == "inline")
    //   return;

    if (window.outerWidth <= 1080) {

      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    document.getElementsByClassName('container-tryon-media')[0].style.display = "inline";
    //document.getElementsByClassName('tryon-product-container')[0].style.display="inline";
    document.getElementsByClassName('tryon-media-menu')[0].style.display = "inline";

    if(!window.CustomSDKIntegration.SDKLoaded)
    {
      document.getElementsByClassName('container_af_loader')[0].style.display="flex";
      document.getElementsByClassName('tryon-media-menu')[0].style.display = "none"; 
    }
    else
    {
      document.getElementsByClassName('tryon-media-menu')[0].style.display = "inline"; 
      document.getElementsByClassName('container_af_loader')[0].style.display="none";
    }

    document.getElementsByClassName('container-product-image')[0].style.display = "none";
    document.getElementsByClassName('tryon-media-content')[0].style.display = "none";
  }

  IConsent(ev) {
    let isChecked = document.getElementById('chkIConsent').checked;
    let arrTryOnMenu = document.getElementsByClassName('tryon-type-btn');

    for (var i = 0; i < arrTryOnMenu.length; i++) {
      if (isChecked) {
        //arrTryOnMenu[i].classList.remove('disabled');
        arrTryOnMenu[i].style.display = "inline";
      } else {
        //arrTryOnMenu[i].classList.add('disabled');
        arrTryOnMenu[i].style.display = "none";
      }
    }
  }

  StartTryon(tryon_type) {
    document.getElementsByClassName('tryon-media-menu')[0].style.display = "none";
    document.getElementsByClassName('tryon-media-content')[0].style.display = "inline";

    window.VmtHelper.clearCanvases();

    if (tryon_type == window.TryOnEnums.UPLOAD_IMAGE) {
      window.CustomSDKIntegration.StartUploadImageTryOn();
      $('.containerMasks').css('display', 'inline');
      // document.getElementById('containerMasks').style.display = "inline";
      window.CustomSDKIntegration.RenderMasks();
    } else if (tryon_type == window.TryOnEnums.LIVE_CAMERA) {
      $('.containerMasks').css('display', 'inline');
      // document.getElementById('containerMasks').style.display = "inline";
      window.CustomSDKIntegration.RenderMasks();
      window.CustomSDKIntegration.StartLiveTryOn();
    } else if (tryon_type == window.TryOnEnums.SELECT_MODEL) {
      window.CustomSDKIntegration.StartChooseModelTryOn();
    }
    window.TryOnEnums.CURRENT_TRYON = tryon_type;

  }

  StartUploadImageTryOn() {
    document.getElementById('tryon-upload-img-input-file').style.display = "inline";
    document.getElementsByClassName('container-choose-model')[0].style.display = "none";
    document.getElementById('tryon-live-canvas-1').style.display = "block";
    var success = window.VmtHelper.registerCanvases(
      "tryon-live-canvas-0",
      "tryon-live-canvas-1",
      "tryon-live-canvas-2"
    );
    if (success) {
      window.VmtHelper.setLive(false);
    }

    document.getElementById("tryon-upload-img-input-file").onchange = (evt) => {
      var img = evt.target.files[0];
      new Compressor(img, {
        quality: 0.8,
        // maxWidth: 1000,

        success(result) {
          var reader = new FileReader();
          reader.onload = (evt1) => {
            var img = new Image();
            img.onload = () => {
              window.VmtHelper.SetRealTimeTracking(false);
              // draw the image on base canvas.
              var base_canvas = document.getElementById("tryon-live-canvas-0");
              var base_ctx = base_canvas.getContext("2d");
              base_canvas.width = img.width;
              base_canvas.height = img.height;
              base_ctx.drawImage(img, 0, 0);

              // call vmt's do detection on the image
              window.VmtHelper.cycleForSingleImage();
            }
            img.src = evt1.target.result;
            document.getElementById('tryon-upload-img-input-file').style.display = "none";
            document.getElementById("tryon-upload-img-input-file").value = "";
            setTimeout(function () {
              window.CustomSDKIntegration.ApplyCurrentPorduct();
            }, 500)
          }
          reader.readAsDataURL(result);
        },
      });
    };

    document.addEventListener('vmt_is_ready', () => {
      // document.getElementById('tryon-live-canvas-1').style.display = "block";
      var success = window.VmtHelper.registerCanvases(
        "tryon-live-canvas-0",
        "tryon-live-canvas-1",
        "tryon-live-canvas-2"
      );

      if (success) {
        window.VmtHelper.setLive(false);
      }
    });
    document.getElementById('tryon-upload-img-input-file').click();
  }

  StartLiveTryOn() {
    document.getElementById('tryon-upload-img-input-file').style.display = "none";
    document.getElementsByClassName('container-choose-model')[0].style.display = "none";
    document.getElementById('tryon-live-canvas-1').style.display = "block";
    var success = window.VmtHelper.registerCanvases(
      "tryon-live-canvas-0",
      "tryon-live-canvas-1",
      "tryon-live-canvas-2"
    );
    if (success) {
      try {
        window.VmtHelper.setLive(true);
        window.VmtHelper.SetYawRange(-0.55, 0.55);
        window.CameraController.streamToCanvasId("tryon-live-canvas-0");
        window.CameraController.onEachFrame(() => {
          window.VmtHelper.cycleForLive();
        });
        // set 'streamToCanvasId' and 'onEachFrame' methods before calling the start()
        window.CameraController.start();
        //window.VmtHelper.applyEyelash(255,0,0,1,'eyelash_1');
        window.CustomSDKIntegration.ApplyCurrentPorduct();
      }
      catch
      {
        console.log('Getting Error')
      }
    }

  }

  StartChooseModelTryOn() {
    document.getElementsByClassName('container-choose-model')[0].style.display = "inline";
    document.getElementById('tryon-upload-img-input-file').style.display = "none";

  }

  SelectModel(ev) {
    let imgsrc = ev.querySelector('img').src;

    document.getElementById('tryon-live-canvas-1').style.display = "block";
    var success = window.VmtHelper.registerCanvases(
      "tryon-live-canvas-0",
      "tryon-live-canvas-1",
      "tryon-live-canvas-2"
    );
    if (success) {
      window.VmtHelper.setLive(false);

      var img = document.createElement('img');
      img.src = imgsrc;
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        // draw the image on base canvas.
        var base_canvas = document.getElementById("tryon-live-canvas-0");
        var base_ctx = base_canvas.getContext("2d");
        base_canvas.width = img.width;
        base_canvas.height = img.height;
        base_ctx.drawImage(img, 0, 0);

        // call vmt's do detection on the image
        window.VmtHelper.cycleForSingleImage();
        document.getElementsByClassName('container-choose-model')[0].style.display = "none";
        window.CustomSDKIntegration.ApplyCurrentPorduct();
      }
    }
  }

  EnableTryOn() {
    let arrMatchedProducts = [];
    if (typeof arrAllProducts != 'undefined') {
      arrMatchedProducts = arrAllProducts.filter((item) => {
        if (window.location.pathname.toLowerCase().indexOf(item.sku_name.toLowerCase()) > -1) {
          return item;
        }

      });

      let arrTryOnContainers = document.getElementsByClassName('try-on-menu-container');

      if (arrTryOnContainers.length > 0) {

        for (var i = 0; i < arrTryOnContainers.length; i++) {

          if (arrMatchedProducts.length == 0) {
            arrTryOnContainers[i].style.display = "none";
          } else {
            arrTryOnContainers[i].style.display = "inline";
          }
        }

        if (
          window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1
          ||
          window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1
        ) {
          window.CustomSDKIntegration.RenderMasks();
        }
      }
    }
  }

  ApplyCurrentPorduct(opacity, productNumber) {
    if (!$('.container-product-image').is(':hidden'))
      return;
    TryOnCommon.ResetZoom();

    let arrCurrentProducts = arrAllProducts.filter((item) => {
      if (window.location.pathname.toLowerCase().indexOf(item.sku_name.toLowerCase()) > -1) {
        return item;
      }

    });


    // filter the product based on variant Id
    if (
      (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.COLOR_IT.toLowerCase()) > -1
        ||
        window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1
        ||
        window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1
        ||
        window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.GLOSS_IT.toLowerCase()) > -1
      )
      &&
      (productNumber == null || productNumber == 0)
    ) {

      //         const urlSearchParams = new URLSearchParams(window.location.search);
      //         const params = Object.fromEntries(urlSearchParams.entries());

      //         let variantId = params.variant;        

      const urlParams = new URLSearchParams(window.location.search);
      let variantId = urlParams.get('variant');

      if (variantId == null) {
        let makeupType = $('.containerMasks ul li img.active').attr('makeup-type');

        //           Face It
        if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1) {
          variantId = '42342322012385';
          arrCurrentProducts = arrCurrentProducts.filter((item) => {
            if (item.variant_id.toLowerCase() == variantId) {
              return item;
            }
          });

          if (makeupType == 'foundation') {
            arrCurrentProducts = arrCurrentProducts.filter((item) => {
              if (item.mask.toLowerCase() == "foundation_fullface") {
                return item;
              }
            });
          }

          if (makeupType == 'contourA') {
            arrCurrentProducts = arrCurrentProducts.filter((item) => {
              if (item.mask.toLowerCase() == "bronzer_fullface_contour_1") {
                return item;
              }
            });
          }

          if (makeupType == 'contourB') {
            arrCurrentProducts = arrCurrentProducts.filter((item) => {
              if (item.mask.toLowerCase() == "bronzer_fullface_contour_2") {
                return item;
              }
            });
          }
          document.getElementsByClassName('container-custom-tryon-range-slider')[0].style.display = "block";
        }

        //           Blend It
        if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1) {
          variantId = '42037667889377';
          arrCurrentProducts = arrCurrentProducts.filter((item) => {
            if (item.variant_id.toLowerCase() == variantId) {
              return item;
            }
          });

          if (makeupType == 'blush') {
            arrCurrentProducts = arrCurrentProducts.filter((item) => {
              if (item.mask.toLowerCase() == "blush_2") {
                return item;
              }
            });
          }

          if (makeupType == 'highlighter_blush') {
            arrCurrentProducts = arrCurrentProducts.filter((item) => {
              if (item.mask.toLowerCase() == "blush_1") {
                return item;
              }
            });
          }

          if (makeupType == 'eyeshadow') {
            arrCurrentProducts = arrCurrentProducts.filter((item) => {
              if (item.mask.toLowerCase() == "eyeshadow_15") {
                return item;
              }
            });
          }
          document.getElementsByClassName('container-custom-tryon-range-slider')[0].style.display = "block";
        }

        //           Color It
        if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.COLOR_IT.toLowerCase()) > -1) {
          variantId = '42342231081185';
          arrCurrentProducts = arrCurrentProducts.filter((item) => {
            if (item.variant_id.toLowerCase() == variantId) {
              return item;
            }
          });

        }

        //           Gloss It
        if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.GLOSS_IT.toLowerCase()) > -1) {
          variantId = '42805350826209';
          arrCurrentProducts = arrCurrentProducts.filter((item) => {
            if (item.variant_id.toLowerCase() == variantId) {
              return item;
            }
          });
        }
      } else {
        arrCurrentProducts = arrAllProducts.filter((item) => {
          if (item.variant_id.toLowerCase() == variantId.toLowerCase()) {
            return item;
          }
        });

        arrCurrentProducts.forEach((item) => {
          let productsList = $('.bubble label');
          let productNumber = '';
          for (let i = 0; i < productsList.length; i++) {
            let productNumber = $(productsList[i]).attr('data-shade-number');
            let productName = $(productsList[i]).attr('data-swatch-name');
            let productNumberAndName = productNumber + ' ' + productName;
            if (item.name.toLowerCase() == productNumberAndName.trim().toLowerCase()) {
              $('.bubble').removeClass('selected');
              $(productsList[i]).parent().addClass('selected');
              document.getElementsByClassName('container-custom-tryon-range-slider')[0].style.display = "block";
            }
          }
        });

      }

      //         if(variantId != null && variantId != '')
      //         {            
      //           arrCurrentProducts = arrAllProducts.filter((item) => {
      //             if (item.variant_id.toLowerCase() == variantId.toLowerCase()) {
      //               return item;
      //             }
      //           });         
      //         } 
      //         else {
      //           if (
      //             window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1
      //           	||
      //             window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.COLOR_IT.toLowerCase()) > -1
      //           	) 
      //           {

      //             $('.bubble').removeClass('selected');
      //             $($('.bubble')[0]).click(function() {
      //               $($('.bubble')[1]).prev().click();
      //             });
      //             return false;
      //           }
      //         }

    }

    // Bonny change - When in EYE mode grey out the colors that should not be put on the eye: peace, humble, giver, fighter, fearless and make the icons non-clickable.
    if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1) {
      let eyeSpecificColors = $('.containerMasks ul li img.active').attr('makeup-type');
      if (eyeSpecificColors == 'eyeshadow') {
        let disableEyeColors = ['Peace', 'Fearless', 'Humble', 'Giver', 'Fighter'];
        disableEyeColors.forEach(function (item) {
          $('.product-form__input input[value="' + item + '"]').attr("disabled", true);
          $('.product-form__input input[value="' + item + '"]').next("a").on('click', function (event) {
            $(this).off("click");
          });
          $('.product-form__input input[value="' + item + '"]').next("a").removeClass('selected');
          $('.product-form__input input[value="' + item + '"]').next("a").addClass('hideColor');
          $('.product-form__input input[value="' + item + '"]').next("a").mouseenter(function () {
            $(this).find('.hide-shade').css('display', 'block');
          });
          $('.product-form__input input[value="' + item + '"]').next("a").mouseleave(function () {
            $(this).find('.hide-shade').css('display', 'none');
          });
        });
      } else {
        let disableEyeColors = ['Peace', 'Fearless', 'Humble', 'Giver', 'Fighter'];
        disableEyeColors.forEach(function (item) {
          $('.product-form__input input[value="' + item + '"]').attr("disabled", false);
          $('.product-form__input input[value="' + item + '"]').next("a").on('click', function (event) {
            $(this).on("click");
          });
          $('.product-form__input input[value="' + item + '"]').next("a").removeClass('hideColor');
          $('.product-form__input input[value="' + item + '"]').next("a").mouseenter(function () {
            $(this).find('.hide-shade').css('display', 'none');
          });
          $('.product-form__input input[value="' + item + '"]').next("a").mouseleave(function () {
            $(this).find('.hide-shade').css('display', 'none');
          });
        });
      }
    }

    // only for Blend It and Face It
    if (
      window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1
      ||
      window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1
    ) {
      let makeupType = $('.containerMasks ul li img.active').attr('makeup-type');

      if (makeupType.toLowerCase() == 'contoura' || makeupType.toLowerCase() == 'contourb') {
        let contMaskType = "";
        if (makeupType.toLowerCase() == 'contoura') {
          contMaskType = "bronzer_fullface_contour_1";
        }
        else if (makeupType.toLowerCase() == 'contourb') {
          contMaskType = "bronzer_fullface_contour_2";
        }
        arrCurrentProducts = arrCurrentProducts.filter(function (item) {
          if (item.type.toLowerCase() == "Contour".toLowerCase() && item.mask.toLowerCase() == contMaskType.toLowerCase()) {
            return item;
          }
        });
      }
      else if (makeupType.toLowerCase() == 'highlighter_blush') {
        arrCurrentProducts = arrCurrentProducts.filter(function (item) {
          if (item.type.toLowerCase() == "Blush".toLowerCase() && item.mask.toLowerCase() == "blush_1".toLowerCase()) {
            return item;
          }
        });
      }
      else if (makeupType.toLowerCase() == 'blush') {
        arrCurrentProducts = arrCurrentProducts.filter(function (item) {
          if (item.type.toLowerCase() == "Blush".toLowerCase() && item.mask.toLowerCase() == "blush_2".toLowerCase()) {
            return item;
          }
        });
      }
      else {
        arrCurrentProducts = arrCurrentProducts.filter(function (item) {
          if (item.type.toLowerCase() == makeupType.toLowerCase()) {
            return item;
          }
        });
      }

    }

    vmt_module._resetAllMakeup();

    if (arrCurrentProducts.length > 0) {
      arrCurrentProducts.forEach((item, i) => {
        let finalOpacity = item.a;
        if (opacity != null) {
          finalOpacity = opacity;
        }

        if (item.min_opacity == undefined) {
          item.min_opacity = 0;
        }

        if (item.max_opacity == undefined) {
          item.max_opacity = 1;
        }

        let alpha_min = item.min_opacity;
        let alpha_max = item.max_opacity;
        // if(alpha_max < finalOpacity)
        // {
        // let opacityForFormula = item.a;
        // let formulatedOpacityForSetInSlider = finalOpacity/opacityForFormula * alpha_max;
        // window.CustomSDKIntegration.SetOpacitySlider(Number(formulatedOpacityForSetInSlider) * 100, Number(alpha_min) * 100, Number(alpha_max) * 100);
        // }
        // else {
        window.CustomSDKIntegration.SetOpacitySlider(Number(finalOpacity) * 100, Number(alpha_min) * 100, Number(alpha_max) * 100);
        // }
        switch (item.type.toLowerCase()) {
          case window.TryOnEnums.LIPSTICK.toLowerCase():

            window.VmtHelper.removeLipstick();
            if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.MONOCHROMATIC_LIP_COLOR.toLowerCase()) > -1 && productNumber > -1) {
              window.VmtHelper.applyLipstick(arrCurrentProducts[productNumber].r, arrCurrentProducts[productNumber].g, arrCurrentProducts[productNumber].b, finalOpacity, arrCurrentProducts[productNumber].finish_intensity, arrCurrentProducts[productNumber].finish_type, arrCurrentProducts[productNumber].glitter_mask, arrCurrentProducts[productNumber].glitter_intensity, arrCurrentProducts[productNumber].shimmer_mask, arrCurrentProducts[productNumber].shimmer_intensity);
            }
            else {
              window.VmtHelper.applyLipstick(item.r, item.g, item.b, finalOpacity, item.finish_intensity, item.finish_type, item.glitter_mask, item.glitter_intensity, item.shimmer_mask, item.shimmer_intensity);
            }

            break;
            
          case window.TryOnEnums.EYESHADOW.toLowerCase():
            // If product is multi JSON than dont remove it 
            window.VmtHelper.removeEyeshadow();
            window.VmtHelper.applyEyeshadow(item.r, item.g, item.b, Number(finalOpacity), item.mask, item.shimmer_mask, item.shimmer_intensity, item.shimmer_r, item.shimmer_g, item.shimmer_b);
            
            break;

          case window.TryOnEnums.EYELINER.toLowerCase():

            // If product is multi JSON than dont remove it 
            if (arrCurrentProducts.length == 1) {
              window.VmtHelper.removeEyeliner();
            }
            window.VmtHelper.applyEyeliner(item.r, item.g, item.b, finalOpacity, item.mask);

            break;

          case window.TryOnEnums.EYELASH.toLowerCase():
            window.VmtHelper.removeEyelash();
            window.VmtHelper.applyEyelash(item.r, item.g, item.b, finalOpacity, item.mask);

            break;

          case window.TryOnEnums.FOUNDATION.toLowerCase():
            window.VmtHelper.removeFoundation();
            window.VmtHelper.applyFoundation(item.r, item.g, item.b, finalOpacity, item.mask, item.smoothing_coefficent, item.finish_type, item.finish_intensity, item.blending_ratio, item.shininess, item.mask_intensity);
            break;

          case window.TryOnEnums.CONTOUR.toLowerCase():

            window.VmtHelper.removeContour();
            window.VmtHelper.applyContour(item.r, item.g, item.b, Number(finalOpacity), item.mask);
            break;

          case window.TryOnEnums.LIPGLOSS.toLowerCase():
            window.VmtHelper.applyLipstick(item.r, item.g, item.b, finalOpacity, item.finish_intensity, item.finish_type, item.glitter_mask, item.glitter_intensity, item.shimmer_mask, item.shimmer_intensity);
            break;

          case window.TryOnEnums.BLUSH.toLowerCase():

            window.VmtHelper.removeBlush();
            window.VmtHelper.applyBlush(item.r, item.g, item.b, finalOpacity, item.mask, item.shimmer_mask, item.shimmer_intensity, item.shimmer_r, item.shimmer_g, item.shimmer_b);
            break;

          case window.TryOnEnums.BRONZER.toLowerCase():

            window.VmtHelper.removeBronzer();
            window.VmtHelper.applyBronzer(item.r, item.g, item.b, finalOpacity, item.mask);

            break;
          case window.TryOnEnums.EYEBROW.toLowerCase():
            window.VmtHelper.applyEyebrow(item.r, item.g, item.b, finalOpacity, item.mask);
            break;
          case window.TryOnEnums.HIGHLIGHTER.toLowerCase():
            window.VmtHelper.removeHighlighter();
            window.VmtHelper.applyHighlighter(item.r, item.g, item.b, finalOpacity, item.mask, item.shimmer_mask, item.shimmer_intensity);
            break;

        }

      });

      if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.COLOR_IT.toLowerCase()) > -1) {
        document.getElementsByClassName('container-custom-tryon-range-slider')[0].style.display = "none";
      } else {
        document.getElementsByClassName('container-custom-tryon-range-slider')[0].style.display = "block";
      }

      let fullFaceFoundation = $('.containerMasks ul li img.active').attr('makeup-type');

      if (
        (
          window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1
          &&
          fullFaceFoundation == 'foundation'
        )
        ||
        (
          window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1
          &&
          fullFaceFoundation == 'blush'
        )
        ||
        (
          window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1
          &&
          fullFaceFoundation == 'highlighter_blush'
        )
      ) {
        $('#normalRangeSlider').hide()
        $('#foundationRangeSlider').show();
      } else {
        $('#normalRangeSlider').show()
        $('#foundationRangeSlider').hide();
      }

      document.getElementsByClassName('tryon-toolbar')[0].style.display = "inline";

    }

  }


  RegisterMultiVariantProductsEvents() {

    if (
      window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.COLOR_IT.toLowerCase()) > -1
      ||
      window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1
      ||
      window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1
      //         ||
      //         window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.GLOSS_IT.toLowerCase()) > -1
    ) {

      //         const urlParams = new URLSearchParams(window.location.search);
      //         let variantId = urlParams.get('variant');
      //         if (variantId) {
      //           console.log('variant id - ', variantId);
      //           document.querySelector('.image-overlay-button').style.display = "none";
      //         } else {        

      //           document.querySelector('.image-overlay-button').style.display = "block";
      //         }
      document.querySelector('.image-overlay-button').style.display = "block";
      document.querySelectorAll('.try-on-menu-container').forEach(function (item) {
        item.style.display = 'block';
      });

      document.querySelectorAll('variant-radios .product-form__input .bubble').forEach(function (item) {

        item.addEventListener('click', function (ev) {
          setTimeout(function () {
            window.CustomSDKIntegration.ApplyCurrentPorduct(null, 0);
          }, 250)
        });

      });

    }

  }

  GoBack(ev, isFrom) {

    // document.getElementById('containerMasks').style.display = "none";
    $('.containerMasks').css('display', 'none');

    window.CustomSDKIntegration.ResetMakeupControls();

    document.getElementsByClassName('container-custom-tryon-range-slider')[0].style.display = "none";

    switch (isFrom.toLowerCase()) {

      case window.TryOnEnums.FROM_MAIN_TRYON.toLowerCase():

        document.getElementsByClassName('container-tryon-media')[0].style.display = "none";
        document.getElementsByClassName('tryon-media-menu')[0].style.display = "none";
        document.getElementsByClassName('tryon-media-content')[0].style.display = "none";

        document.getElementsByClassName('container-product-image')[0].style.display = "inline";

        document.getElementById('tryon-live-canvas-1').style.display = "none";

        break;

      case window.TryOnEnums.FROM_MAIN_TRYON_CONTENT.toLowerCase():

        document.getElementsByClassName('tryon-media-content')[0].style.display = "none";
        document.getElementsByClassName('tryon-media-menu')[0].style.display = "inline";
        document.getElementById('tryon-live-canvas-1').style.display = "none";

        break;
    }

  }

  ResetMakeupControls() {

    window.VmtHelper.clearMakeup();

    if (window.TryOnEnums.CURRENT_TRYON == window.TryOnEnums.UPLOAD_IMAGE) {
      window.VmtHelper.clearCanvases();
    } else if (window.TryOnEnums.CURRENT_TRYON == window.TryOnEnums.LIVE_CAMERA) {
      window.CameraController.stop();
      window.VmtHelper.clearCanvases();
    } else if (window.TryOnEnums.CURRENT_TRYON == window.TryOnEnums.SELECT_MODEL) {
      window.VmtHelper.clearCanvases();
    }

    //$('.makeover-product-icon.active').removeClass('active');
    document.getElementsByClassName('tryon-toolbar')[0].style.display = "none";


  }

  ChangeMakupOpacity() {

    let contolrRef = document.getElementsByClassName('custom-tryon-range-slider')[0];
    contolrRef.style.display = "inline";
    var value = (contolrRef.value - contolrRef.min) / (contolrRef.max - contolrRef.min) * 100;

    contolrRef.style.background = 'linear-gradient(to right, #4cc2bf 0%, #4cc2bf ' + value + '%, #4cc2bf ' + value + '%, #4cc2bf 100%)';
    vmt_module._resetAllMakeup();
    window.CustomSDKIntegration.ApplyCurrentPorduct(Number(value) / 100);

  }

  SetOpacitySlider(value, minOpacity, maxOpacity) {

    if (isNaN(minOpacity)) {
      minOpacity = 0;
    }

    if (isNaN(maxOpacity)) {
      maxOpacity = 100;
    }

    $("#intensitySlider").slider({
      range: "max",
      step: 1,
      animate: "fast",
      value: value,
      slide: function slider_slide(event, ui) {
        if (ui.value < minOpacity) {
          return false;
        }
        if (ui.value > maxOpacity) {
          return false;
        }
      },
      stop: function (event, ui) {
        vmt_module._resetAllMakeup();
        // if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1) {
        //   let currentProductname = $('.bubble.selected .swatch-labels').attr('data-swatch-name');
        //   let productType = $('.containerMasks li img.active').attr('makeup-type');

        //   let arrFilteredProducts = [];
        //   let arrAllClonedProducts = JSON.parse(JSON.stringify(arrAllProducts));
        //   let dividentFactor = 0.0075;
        //   if (productType.toLowerCase() == 'contoura') {
        //     arrFilteredProducts = arrAllClonedProducts.filter(function (item) {
        //       if (item.type.toLowerCase() == 'contour' && item.mask.toLowerCase() == 'bronzer_fullface_contour_1')
        //         return item;
        //     });
        //     dividentFactor = 0.01;
        //   }
        //   else if (productType.toLowerCase() == 'contourb') {
        //     arrFilteredProducts = arrAllClonedProducts.filter(function (item) {
        //       if (item.type.toLowerCase() == 'contour' && item.mask.toLowerCase() == 'bronzer_fullface_contour_2')
        //         return item;
        //     });
        //     dividentFactor = 0.01;
        //   }
        //   else if (productType.toLowerCase() == 'foundation') {
        //     arrFilteredProducts = arrAllClonedProducts.filter(function (item) {
        //       if (item.type.toLowerCase() == 'foundation' && item.mask.toLowerCase() == 'foundation_fullface')
        //         return item;
        //     });
        //     dividentFactor = 0.0075;
        //   }
        // find the exact variant by comparison name
        //   let arrProduct = arrFilteredProducts.filter(function (item) {
        //     if (item.name.toLowerCase().indexOf(currentProductname.toLowerCase()) > -1)
        //       return item;
        //   });
        //   if (arrProduct.length > 0) {
        //     let productOpacity = arrProduct[0].a;
        //     let finalOpacity = (((Number(ui.value) / 100) / dividentFactor) * productOpacity) / 100

        //     window.CustomSDKIntegration.ApplyCurrentPorduct(finalOpacity);
        //   }
        // }
        // else {
        window.CustomSDKIntegration.ApplyCurrentPorduct(Number(ui.value) / 100);
        // }
      }
    });

    //       $("#intensitySlider").slider({
    //         range: "max",
    //         step: 1,
    //         animate: "fast",
    //         value: value,
    //         min: minOpacity,
    //         max: maxOpacity,
    //         slide: function slider_slide(event, ui) {
    //           vmt_module._resetAllMakeup();
    //           window.CustomSDKIntegration.ApplyCurrentPorduct(Number(ui.value) / 100);
    //         }

    //       });



    //       let contolrRef = document.getElementsByClassName('custom-tryon-range-slider')[0];
    //       contolrRef.value = value;

    //       var sliderValue = (contolrRef.value - contolrRef.min) / (contolrRef.max - contolrRef.min) * 100;
    //       contolrRef.style.background = 'linear-gradient(to right, #4cc2bf 0%, #4cc2bf ' + sliderValue + '%, #4cc2bf ' + sliderValue + '%, #4cc2bf 100%)';

  }

  groupArrayOfObjects(list, key) {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  RenderMasks() {
    $('.containerMasks').empty();
    if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.BLEND_IT.toLowerCase()) > -1) {


      //           Ali request this order, issue no. is E5
      // 			$('#containerMasks').append(
      //             `<ul>
      // 				<li> <img makeup-type="eyeshadow" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/9/assets/eyeshadow-light-wash.png" onclick="window.CustomSDKIntegration.SelectMask(event);"/> </li>
      // 				<li> <img makeup-type="blush" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/9/assets/blush-full-cheekbones.png" onclick="window.CustomSDKIntegration.SelectMask(event);"/> </li>				
      // 				<li> <img class="active" makeup-type="highlighter_blush" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/9/assets/highlighter-shimmer.png" onclick="window.CustomSDKIntegration.SelectMask(event);"/> </li>
      // 			</ul>`
      //             );

      //           Bonny request this order

      $('.containerMasks').append(
        `<ul>
            <li> <img class="active" makeup-type="blush" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/7/assets/blush-full-cheekbones.png?v=1653061894" onclick="window.CustomSDKIntegration.SelectMask(event);"/> <span>cheek</span></li>				
            <li> <img makeup-type="highlighter_blush" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/7/assets/highlighter-shimmer.png?v=1653061934" onclick="window.CustomSDKIntegration.SelectMask(event);"/> <span>face</span></li>
            <li> <img makeup-type="eyeshadow" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/7/assets/eyeshadow-light-wash.png?v=1653068670" onclick="window.CustomSDKIntegration.SelectMask(event);"/> <span>eye</span></li>
          </ul>`
      );
    }
    else if (window.location.pathname.toLowerCase().indexOf(window.TryOnEnums.FACE_IT.toLowerCase()) > -1) {

      $('.containerMasks').append(
        `<ul>
          <li> <img class="active" makeup-type="foundation" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/7/assets/full-face-foundation.png?v=1653061927" onclick="window.CustomSDKIntegration.SelectMask(event);"/> <span>full face</span></li>
          <li> <img makeup-type="contourA" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/7/assets/contourA.png?v=1653061903" onclick="window.CustomSDKIntegration.SelectMask(event);"/> <span>contour</span></li>
          <li> <img makeup-type="contourB" src="https://cdn.shopify.com/s/files/1/0550/1118/0769/t/7/assets/contourB.png?v=1653061910" onclick="window.CustomSDKIntegration.SelectMask(event);"/> <span>conceal</span></li>
        </ul>`
      );
    }
  }

  SelectMask(ev) {

    $('.containerMasks ul li img').removeClass('active');
    $(ev.target).addClass('active');
    window.CustomSDKIntegration.ApplyCurrentPorduct(null, 0);

  }

}



if (window.CustomSDKIntegration === undefined) {
  window.CustomSDKIntegration = new CustomSDKIntegration();
}


// (function () {
//     window.CustomSDKIntegration.EnableTryOn();


// })();